import React from 'react';

import {
  Button,
  Card,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';

import type { PhotoUrlType } from '@/domain/photo/redux';

import CardMediaImage from '@/components/CardMediaImage';
import PhotoModal from '@/components/PhotoModal';

/**
 * 写真タイプ
 */
export type PhotoType = {
  /** 名前 */
  name: string,
  /** ID */
  id: string,
  /** URL */
  url?: PhotoUrlType,
}

/**
 * プロパティ
 */
export type Props = {
  /** 施設ID */
  nurseryId: string,
  /** 写真リスト */
  photoList: PhotoType[],
  /** 選択IDs */
  selectedIds: string[],
  /** 選択IDsをセット */
  setSelectedIds: (ids: string[]) => void,
};

const SelectPhoto: React.FC<Props> = ({
  nurseryId,
  photoList,
  selectedIds,
  setSelectedIds,
}) => {
  const [previewS3Path, setPreviewS3Path] = React.useState<string | undefined>(undefined);
  const [innerWidth, setInnerWidth] = React.useState<number>(window.innerWidth);
  const [_innerHeight, setInnerHeight] = React.useState<number>(window.innerHeight);
  React.useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
      setInnerHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const div = Math.floor(innerWidth / 400);
  const width = Math.round((innerWidth - 60 - div * 8) / div);
  return (
    <>
      <ImageList cols={div}>
        {photoList.map((item) => {
          const isSelected = selectedIds.includes(item.id);
          return (
            <ImageListItem
              key={item.id}
              style={{
                width,
                border: 'solid 1px #000',
                backgroundColor: '#aaa',
              }}
            >
              <Card style={{ margin: 'auto' }}>
                <CardMediaImage
                  nurseryId={nurseryId}
                  s3Path={`WagakoNurseryPhoto_PhotoEntity/${item.id}/thumbnail.webp`}
                  onClick={() => setPreviewS3Path(`WagakoNurseryPhoto_PhotoEntity/${item.id}/sample.webp`)}
                  alt={item.id}
                  opacity={isSelected ? 0.5 : 1}
                  width={width}
                  objectFit="cover"
                />
              </Card>
              <ImageListItemBar
                subtitle={item.name}
                actionIcon={(
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: '5px' }}
                    onClick={() => {
                      const newIds: string[] = [];
                      if (isSelected) {
                        // 選択から取り除く
                        for (let i = 0; i < selectedIds.length; i += 1) {
                          if (selectedIds[i] !== item.id) {
                            newIds.push(selectedIds[i]);
                          }
                        }
                      } else {
                        // 追加する
                        for (let i = 0; i < selectedIds.length; i += 1) {
                          newIds.push(selectedIds[i]);
                        }
                        newIds.push(item.id);
                      }
                      setSelectedIds(newIds);
                    }}
                  >
                    {isSelected ? 'キャンセル' : '購入する'}
                  </Button>
                )}
              />
            </ImageListItem>
          );
        })}
      </ImageList>
      {previewS3Path && (
        <PhotoModal
          s3Path={previewS3Path}
          close={() => setPreviewS3Path(undefined)}
          nurseryId={nurseryId}
        />
      )}
    </>
  );
};

export default SelectPhoto;
